import type { IFilter } from '@models/Filter'

import { apiClient } from '../../gateways/api'
import type { GeblokkeerdeWekenSearch } from '../types/GeblokkeerdeWekenSearch'

export { initialState, createFilters, searchGeblokkeerdeWeken }

const initialState: GeblokkeerdeWekenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      gebied: [],
      organisatie: null,
    },
    sort: { sortBy: 'gebiedscode', sortDirection: 'asc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  gebied,
  organisatie,
}: GeblokkeerdeWekenSearch['query']['filters']) => {
  const filters: IFilter[] = [
    { name: 'status', value: 'actief', operator: 'eq' },
  ]

  if (gebied && gebied.length > 0) {
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  }

  if (organisatie) {
    filters.push({
      name: 'organisatie',
      value: organisatie.code,
      operator: 'eq',
    })
  }

  return filters
}

const searchGeblokkeerdeWeken = async ({
  query,
}: {
  query: GeblokkeerdeWekenSearch['query']
}): Promise<GeblokkeerdeWekenSearch['data']> => {
  const { filters, sort } = query

  const { data } = await apiClient({
    method: 'POST',
    url: '/rest/planning/geblokkeerdeweken/search',
    data: { filters: createFilters(filters), ...sort },
  })

  return data
}
